module.exports = __webpack_public_path__ + "img/2134_purist_blue.56fa8e93.jpg";